// extracted by mini-css-extract-plugin
export default {"actionArea":"Tickets_actionArea__2Kmtp","seeDetailsButton":"Tickets_seeDetailsButton__pXLL1","scanButton":"Tickets_scanButton__16-7U"};